import * as React from "react";

interface LevelUpMessageProps {
  level: number;
  onClick?: () => void;
}

const getLevelUpGif = (level: number): string => {
  if (level >= 1 && level <= 4) {
    return "/assets/level-up/level-up-1.gif";
  } else if (level >= 5 && level <= 9) {
    return "/assets/level-up/level-up-2.gif";
  } else if (level >= 10 && level <= 24) {
    return "/assets/level-up/level-up-3.gif";
  } else if (level >= 25 && level <= 49) {
    return "/assets/level-up/level-up-4.gif";
  } else if (level >= 50 && level <= 99) {
    return "/assets/level-up/level-up-5.gif";
  } else {
    return "/assets/level-up/level-up-6.gif";
  }
};

export const LevelUpMessage = ({ level, onClick }: LevelUpMessageProps) => {
  const gifSrc = getLevelUpGif(level);

  return (
    <div
      className="fixed top-0 left-0 w-full h-[100vh] z-[100] flex flex-col justify-center items-center overflow-hidden text-[24px] cursor-pointer"
      style={{ background: "rgba(0,0,0,0.8)" }}
      onClick={onClick}
    >
      <img className="w-[235px] h-[162px]" src={gifSrc} alt="level up" />
      <span>level up!</span>
      <span>You are now</span>
      <span
        className="text-[48px] text-center"
        style={{
          background: "linear-gradient(90deg, #01FE45 0%, #0099FE 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        LVL {level}
      </span>
    </div>
  );
};
